export function alertBeforeUnload(e: BeforeUnloadEvent) {
    // Cancel the event
    e.preventDefault();
    // Chrome requires returnValue to be set
    e.returnValue = "";
}
